import {
  actionsForRecordset,
  addDatasource
} from 'store/actions/recordset';

import { getDatasourceFor } from 'firebase/datasource';
import { config } from 'store/reducers/recordsets/users';

export default addDatasource(actionsForRecordset('users', config), getDatasourceFor(config));